import { Directive } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaRenonciationFormBuilder extends PrFormAbstract {
  generate(entity: any): UntypedFormGroup {
    this.form = this.formBuilder.group({
      lastName: [entity ? entity.lastName : null, Validators.required],
      firstName: [entity ? entity.firstName : null, Validators.required],
      contractNumber: [
        entity ? entity.contractNumber : null,
        Validators.required,
      ],
      renunciationMethod: [
        entity && entity.renunciationMethod
          ? entity.renunciationMethod
          : 'EMAIL',
        Validators.required,
      ],
      reason: [entity ? entity.reason : null, Validators.maxLength(200)],
    });

    return this.form;
  }

  extract() {
    return {
      lastName: this.emptyIsNull(this.form.value.lastName),
      firstName: this.emptyIsNull(this.form.value.firstName),
      contractNumber: this.emptyIsNull(this.form.value.contractNumber),
      renunciationMethod: this.emptyIsNull(this.form.value.renunciationMethod),
      reason: this.emptyIsNull(this.form.value.reason),
    };
  }
}
